module.exports = __webpack_public_path__ + "img/qr2.a7075062.jpg";